import React from 'react';
import PropTypes from 'prop-types';
import Box from '../../../components/Box';
import Text from '../../../components/Text';
import Heading from '../../../components/Heading';
import Logo from '../../../components/UIElements/Logo';
import Container from '../../../components/UI/Container';
import FooterWrapper, { List, ListItem } from './footer.style';
import { enFr } from '../../../utils';
import { openCalendarModal } from '../../../utils/modal-helpers.jsx';

const Footer = ({
  row,
  col,
  colOne,
  colTwo,
  titleStyle,
  logoStyle,
  textStyle,
}) => {
  return (
    <FooterWrapper>
      <Container className="footer_container">
        <Box className="row" {...row}>
          <Box {...colOne} className="colOne">
            <Logo
              href="#welcome"
              useWhiteLogo={true}
              title="Awaken Solutions"
              logoStyle={logoStyle}
              width={150}
            />
            <div style={{ marginTop: 10, fontSize: '14px' }}>
              <a
                className="whiteLink"
                href={enFr(
                  'mailto:info@awakensolutions.com',
                  'mailto:info@solutionsawaken.com'
                )}
              >
                {enFr('info@awakensolutions.com', 'info@solutionsawaken.com')}
              </a>
            </div>
            <div style={{ marginTop: 5, fontSize: '14px' }}>
              <a className="whiteLink" href="tel:+15149954967">
                +1 514 995 4967
              </a>
            </div>
          </Box>
          <Box {...colTwo} className="colTwo">
            <Heading
              content={enFr(
                'READY TO BUILD SOMETHING TOGETHER?',
                'PRÊT À CONSTRUIRE QUELQUE CHOSE ENSEMBLE?'
              )}
              {...titleStyle}
              style={{ color: '#ffffff', textAlign: 'right' }}
            />
            <div style={{ color: '#ffffff', textAlign: 'right' }}>
              <Text
                content={enFr(
                  'A ',
                  'Un '
                )}
                {...textStyle}
                style={{ color: '#ffffff', textAlign: 'right', display: 'inline' }}
              />
              <a
                className="whiteLink"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  openCalendarModal();
                }}
                style={{ cursor: 'pointer' }}
              >
                {enFr('30-minute strategy call', 'appel stratégique de 30 minutes')}
              </a>
              <Text
                content={enFr(
                  ' can go a long way.',
                  ' peut aller loin.'
                )}
                {...textStyle}
                style={{ color: '#ffffff', textAlign: 'right', display: 'inline' }}
              />
            </div>
          </Box>
        </Box>
      </Container>
    </FooterWrapper>
  );
};

Footer.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  colOne: PropTypes.object,
  colTwo: PropTypes.object,
  titleStyle: PropTypes.object,
  textStyle: PropTypes.object,
  logoStyle: PropTypes.object,
};

Footer.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
  },
  colOne: {
    width: [1, '35%', '35%', '23%'],
    mt: [0, '13px'],
    mb: ['30px', 0],
    pl: ['15px', 0],
    pr: ['15px', '15px', 0],
  },
  colTwo: {
    width: ['100%', '65%', '65%', '77%'],
    pl: ['10px', '15px', '15px', '15px'],
    pr: ['10px', '15px', '15px', '15px'],
    alignSelf: 'center',
    textAlign: 'center',
  },
  col: {
    width: ['100%', '50%', '50%', '25%'],
    pl: '15px',
    pr: '15px',
    mb: '30px',
  },
  titleStyle: {
    color: '#343d48',
    fontSize: '16px',
    fontWeight: '700',
    mb: '15px',
    textAlign: 'center',
  },
  logoStyle: {
    width: '200px',
    mb: '15px',
  },
  textStyle: {
    display: 'block',
    color: '#777',
    fontSize: '16px',
    mb: '0px',
    textAlign: 'center',
  },
};

export default Footer;
